// extracted by mini-css-extract-plugin
export default {"aeroLogo":"ProtectedRoutes_aeroLogo__b08Hb","navbar":"ProtectedRoutes_navbar__9jtli"};